<ng-template #content let-modal>
  <app-language-selection
    (modalClose)="modal.dismiss()"
  ></app-language-selection>
</ng-template>
<header class="border-bottom" *ngVar="displayHeader$ | async as displayHeader">
  <div *ngIf="displayHeader">
    <span aria-hidden="true" hidden="hidden" id="useremail">{{
      userEmail$ | async
    }}</span>
    <span aria-hidden="true" hidden="hidden" id="userphone">{{
      userPhone$ | async
    }}</span>
  </div>
  <nav
    class="navbar navbar-expand-lg header"
    *ngVar="
      giftCardService.giftCardItemsAddedToBasketAsObservable$
        | async as giftCardItems
    "
  >
    <div class="container">
      <a
        class="navbar-brand w-auto cursor-pointer"
        [routerLink]="['locations']"
      >
        <img alt="logo" [src]="logoDataUrl$ | async" width="105" height="24" />
      </a>
      <div
        class="d-flex flex-row"
        data-testid="language-profile-header"
        *ngIf="displayHeader"
      >
        <div
          class="d-flex gap-2 align-items-center cursor-pointer"
          (click)="modalService.open(content, { fullscreen: true })"
        >
          <div class="country-flag" [class]="'fi fi-' + flagCountryCode"></div>
          <div>{{ language | uppercase }}</div>
        </div>
        @if (onlineGiftCardActive$ | async) {
          <div
            class="d-flex ms-3 align-items-center"
            *ngIf="giftCardItems.length > 0"
          >
            <icon
              [routerLink]="['gift-cards/basket']"
              class="cursor-pointer full-basket"
              data-testid="full-basket"
            ></icon>
          </div>
          <div class="d-flex ms-3 align-items-center">
            <icon
              [routerLink]="['gift-cards']"
              class="cursor-pointer gift-icon"
              data-testid="gift-cards-icon"
            ></icon>
          </div>
        }
        <app-profile-dropdown></app-profile-dropdown>
      </div>
    </div>
  </nav>
</header>
